<template>
  <div class="empty-data">
    <img
      v-if="emptyType === 'matter'"
      class="empty-img-matter"
      src="~@/assets/image/empty/empty-matter.png"
      alt="empty"
    >
    <img
      v-else
      class="empty-img-list"
      src="~@/assets/image/empty/empty-list.png"
      alt="empty"
    >
    <span>{{i18n.t(emptyText)}}</span>
  </div>
</template>

<script>
import i18n from '@/lang'

export default {
  name: 'EmptyData',
  props: {
    emptyType: {
      type: String,
      default: ''
    },
    emptyText: {
      type: String,
      default: '查询无记录'
    }
  },
  data () {
    return {
      i18n
    }
  }
}
</script>

<style lang="less" scoped>
.empty-data {
  text-align: center;
  padding-top: 50px;
  img {
    display: block;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
  .empty-img-list {
    width: 126px;
    height: 126px;
  }
  .empty-img-matter {
    width: 156px;
    height: 126px;
  }
  span {
    font-size: 14px;
    font-weight: 400;
    color: @blackLess;
    line-height: 22px;
    margin-top: 15px;
  }
}
</style>
